import React from 'react'
import PropTypes from 'prop-types';
import { Icons, UnitDisplay } from '@leverege/api-attributes';
import { ValueCard } from '~/views';

export default class UnitViewer extends React.Component {

  static propTypes = {
    device : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    name : PropTypes.string
  }

  render() {
    const { attribute : attr, name, onClick, editable, value } = this.props
    if ( attr == null ) {
      return <div />
    }
    let val = null // '---'
    if ( typeof value === 'number' ) { 
      val = `${value.toFixed( 2 )} ${UnitDisplay.toDisplay( attr.base, attr )}`
    } else if ( typeof value === 'string' ) {
      const n = parseFloat( value )
      if ( !isNaN( n ) ) {
        val = `${n.toFixed( 2 )} ${UnitDisplay.toDisplay( attr.base, attr )}`
      }
    }
    const icon = Icons.getIcon( attr )
    return (
      <ValueCard name={name || attr.name} editable={editable} value={val} icon={icon} onClick={onClick} />
    ) 
  }
}
